// extracted by mini-css-extract-plugin
export default {"qnaArea":"qna_qnaArea__rZyWK","anyQuestionsText":"qna_anyQuestionsText__S4SFk","kakaoQnaBtn":"qna_kakaoQnaBtn__JAEBI","icon":"qna_icon__LnbjI","text":"qna_text__EYrnr"};